import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Tooltip from 'dashboard/components/Tooltip';
import Sticker from 'design-system/components/Sticker';

const TagsContainer = styled('div')`
  display: flex;
  align-items: center;
  max-width: 300px;
`;

const StickerContainer = styled('div')`
  padding-right: ${Spacing[4]};
`;

export interface GraphTextTagsProp {
  tags: string[];
}

const MAX_TAG_SIZE = 35;
const TAG_TRUNCATE_SIZE = 25;

const GraphTextTags = ({ tags }: GraphTextTagsProp) => {
  const truncateTag = (tag: string) => {
    return tag.length > MAX_TAG_SIZE ? tag.substring(0, TAG_TRUNCATE_SIZE) + '...' : tag;
  };

  return (
    <TagsContainer>
      {tags.map((tag) =>
        tag.length > MAX_TAG_SIZE ? (
          <Tooltip placement='top' trigger='hover' tooltip={tag} key={tag}>
            <StickerContainer>
              <Sticker>{truncateTag(tag)}</Sticker>
            </StickerContainer>
          </Tooltip>
        ) : (
          <StickerContainer key={tag}>
            <Sticker>{truncateTag(tag)}</Sticker>
          </StickerContainer>
        ),
      )}
    </TagsContainer>
  );
};

export default GraphTextTags;
